import { Col, Modal, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import { platebniInstrukcePDFapi } from 'services/spravaEmitenta/amlzData';
import {
    EPristupStav,
    ISubjPravo,
    biAmlzRerouteApi,
    pdfBiRerouteApi,
    pdfPodpisApi,
    zadostPravoGET,
    zadostPravoPOST,
    zadostPravoPUT,
    zadostPravoZalozit
} from 'services/spravaEmitenta/zadostPravo';

import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

import AgendaAmlz from './formular/AgendaAmlzFormular';

// SEM IDEM AK PROFIL NEMA C2EDIT zo sluzby emitent

const ZadostSpravaOsob: React.FC = () => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { aktivniFirma, zadostAgenda, NotificationComponent, language, profily } = useContext(Context);
    const { confirm } = Modal;
    const { setLevel } = useProfily();
    const [showInstrukceAfterFinish, setshowInstrukceAfterFinish] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [zadostData, setZadostData] = useState<ISubjPravo>();
    const [submitZadostData, setSubmitZadostData] = useState<ISubjPravo>();
    const [putResp, setPutResp] = useState<string>('');
    const [isSubmittingManually, setIsSubmittingManually] = useState<boolean>(false);
    const [personDataFinish, setPersonDataFinish] = useState<boolean>(false);
    const isLegalEntity = profily?.typprihlaseni === 'DLT';

    const apiListZadostPravoOsoby = (idZadost: number | string, _: number | string, personObject: ISubjPravo) => {
        return {
            downloadSignature: () =>
                zadostPravoPUT(idZadost, personObject).then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        pdfPodpisApi(idZadost!);
                    }
                }),
            pdfBiReroute: () =>
                zadostPravoPUT(idZadost, personObject).then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        return pdfBiRerouteApi(idZadost || 0, language);
                    }
                }),
            biReroute: () =>
                zadostPravoPUT(idZadost, personObject).then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        return biAmlzRerouteApi(idZadost, language);
                    }
                })
        };
    };

    useEffect(() => {
        if (zadostAgenda?.pristupc2?.stav === EPristupStav.ZADNA) {
            confirm({
                title: <TranslateText>POTVRDENI</TranslateText>,
                content: <TranslateText>AMLZ_AGENDA_ZADOST_CONFIRM</TranslateText>,
                cancelText: <TranslateText>NE</TranslateText>,
                okText: <TranslateText>ANO</TranslateText>,
                onOk() {
                    setLoading(true);
                    zadostPravoZalozit('PRISTUPC2')
                        .then(resp => {
                            setLevel('zadostAgenda', {
                                pristupc2: resp.pristupc2
                            });
                            zadostPravoGET(resp.pristupc2?.id || 0)
                                .then(data => setZadostData(data))
                                .finally(() => setLoading(false));
                        })
                        .catch(() => setLoading(false));
                },
                onCancel() {
                    navigateWorkaround(
                        `/firma/${aktivniFirma?.iducet}${
                            isLegalEntity
                                ? routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY
                                : routePathEnum.EMITENT_ZASTUPUJICI_OSOBY
                        }`
                    );
                }
            });
        } else {
            setLoading(true);
            zadostPravoGET(zadostAgenda?.pristupc2?.id || 0)
                .then(resp => setZadostData(resp))
                .finally(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (submitZadostData) {
            if (!personDataFinish) {
                (setLoading(true), zadostPravoPUT(zadostAgenda?.pristupc2?.id!, submitZadostData))
                    .then(data => {
                        if (isSubmittingManually && data.stav === 'OK') {
                            NotificationComponent({
                                type: ENotificationType.SUCCESS,
                                //   title: 'IDENTIFIKACE_OSOBY',
                                description: 'AMLZ_C2_PUT_SUCCESS'
                            });
                            setIsSubmittingManually(false);
                        }
                        data && setPutResp(data.stav === 'OK' ? '' : data.stav);
                        zadostPravoGET(zadostAgenda?.pristupc2?.id || 0)
                            .then(rezp => {
                                setZadostData(rezp);
                                if (showInstrukceAfterFinish) {
                                    setLoading(true);
                                    platebniInstrukcePDFapi(zadostAgenda?.pristupc2?.id!, language).finally(() =>
                                        setLoading(false)
                                    );
                                    setshowInstrukceAfterFinish(false);
                                }
                            })
                            .finally(() => setLoading(false));
                    })
                    .catch(() => setLoading(false));
            } else {
                zadostPravoPOST(zadostAgenda?.pristupc2?.id!, submitZadostData)
                    .then(() => {
                        NotificationComponent({
                            type: ENotificationType.SUCCESS,
                            //   title: 'IDENTIFIKACE_OSOBY',
                            description: 'LEI_SPARAVA_ZADOST_SUCCESS_TITLE'
                        });
                        navigateWorkaround(
                            `/firma/${aktivniFirma?.iducet}${
                                isLegalEntity
                                    ? routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY
                                    : routePathEnum.EMITENT_ZASTUPUJICI_OSOBY
                            }`
                        );
                    })
                    .finally(() => setLoading(false));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostAgenda?.pristupc2?.id, submitZadostData]);

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text={isLegalEntity ? 'IDENTIFIKACE_OSOBY_LEGALENTITY' : 'IDENTIFIKACE_OSOBY'} />
            {isLegalEntity && <Paragraph text="IDENTIFIKACE_OSOBY_ZADOST_LEGALENTITY_TEXT" />}
            {zadostAgenda?.pristupc2?.id && zadostData ? (
                <Row gutter={8}>
                    <Col span={24}>
                        <AgendaAmlz
                            isLegalEntity={isLegalEntity}
                            setPdfCheckError={setPutResp}
                            pdfCheckError={putResp}
                            personData={zadostData}
                            setPersonData={setZadostData}
                            setSubmitPersonData={setSubmitZadostData}
                            idZadosti={zadostAgenda?.pristupc2?.id}
                            setshowInstrukceAfterFinish={setshowInstrukceAfterFinish}
                            setPersonDataFinish={setPersonDataFinish}
                            //    putResp={putResp}
                            mode={'zadostOOsoby'}
                            apiList={apiListZadostPravoOsoby}
                            setIsSubmittingManually={setIsSubmittingManually}
                        />{' '}
                    </Col>
                </Row>
            ) : (
                <></>
            )}
        </LoadingWrapper>
    );
};
export default ZadostSpravaOsob;
